<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex px-0 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card flat min-height="100vh">
          <v-card-title class="elevation-1">
            Promo Code
            <v-spacer></v-spacer>
            <v-flex md2>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="green"
                    width="100%"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add <v-icon x-small>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider" ref="addcat">
                    <v-card-title>
                      <span class="headline">Add Promocode</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                      

                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              label="Promo Code"
                              v-model="promoCode.code"
                            >
                            </v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              label="Discount"
                              v-model="promoCode.discount"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" text-left>
                            
                            <v-text-field
                              label="Description"
                              v-model="promoCode.description"
                            >
                            </v-text-field>
                          </v-col>
                           <v-col cols="12" text-left>
                            
                            <v-text-field
                             type="number"
                              label="Maximun Amount"
                              v-model="promoCode.maxAmount"
                            >
                            </v-text-field>
                          </v-col>

                          <v-col cols="12">
                            <v-switch
                              label="Is free Delivery"
                              v-model="promoCode.freeDelivery"
                            ></v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="max KM "
                              :disabled="
                                promoCode.freeDelivery == false ? true : false
                              "
                              v-model="promoCode.maxKM"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-switch
                              label="Is free Packing Charge"
                              v-model="promoCode.packingCharge"
                            ></v-switch>
                          </v-col>
                          <v-col cols="12">
                            <v-switch
                              label="Is for 1st Order"
                              v-model="promoCode.firstOrder"
                            ></v-switch>
                          </v-col>

                          <!-- <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              v-model="offerData.productId"
                              :items="products"
                              :rules="[rules.required]"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              clearable
                              placeholder="Product Name"
                              label="Product Name"
                            ></v-autocomplete>
                          </v-col> -->
                          <!-- <v-col cols="12" sm="12" md="12" class="text-left">
                            <span class="homeText">
                              Description of the Offer</span
                            >
                            <div id="app" class="pt-3">
                              <vue-editor
                                v-model="offerData.description"
                              ></vue-editor>
                            </div>
                          </v-col> -->

                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="offerData.startingDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="promoCode.startDate"
                                  :rules="[rules.required]"
                                  label="Select Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="promoCode.startDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(promoCode.startDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              :return-value.sync="promoCode.endDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="promoCode.endDate"
                                  label="Select Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="promoCode.endDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu1 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu1.save(promoCode.endDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <!-- <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="offerData.startingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.startingTime"
                                  :rules="[rules.required]"
                                  label="Starting Time"
                                  prepend-icon="mdi-clock"
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu3"
                                v-model="offerData.startingTime"
                                full-width
                                @click:minute="
                                  $refs.menu3.save(offerData.startingTime)
                                "
                              ></v-time-picker>
                            </v-menu>
                          </v-col> -->
                          <!-- <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="offerData.endingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.endingTime"
                                  :rules="[rules.required]"
                                  prepend-icon="mdi-clock"
                                  label="Ending Time"
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu4"
                                v-model="offerData.endingTime"
                                full-width
                                @click:minute="
                                  $refs.menu4.save(offerData.endingTime)
                                "
                              ></v-time-picker>
                            </v-menu>
                          </v-col> -->
                          <!-- <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              @stepper="winStepper"
                              :height="'9'"
                              :width="'16'"
                              :heading="'Upload Offer Image (Aspect Ratio: 16/9)'"
                              :componentType="'offerImage'"
                            />
                          </v-col> -->
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
          <div v-if="offerList.length > 0">
            <v-layout wrap justify-start v-if="offerList.length > 0">
              <v-flex v-for="(item, i) in offerList" :key="i" md6 pa-4>
                <v-card style="line-height: 16px">
                  <v-layout wrap>
                    <!-- <v-flex md3 pl-2>
                      <img
                        v-if="item.photo"
                        v-viewer
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        :src="baseURL + '/file/get/' + item.photo"
                        height="180px"
                      />

                      <v-img
                        v-else
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        src="../../assets/images/no-image.png"
                        height="180px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#FF2323"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex> -->
                    <v-flex md12>
                      <v-layout wrap justify-center px-2>
                        <v-flex text-center xs12 pt-4>
                          <router-link :to="'promocodeView?id=' + item._id ">
                          <v-card color="yellow">
                            <v-layout wrap>
                              <v-flex xs12 pa-3>
                                <span
                                  style="
                                    font-size: 18px;
                                    color: #000000;
                                    font-weight: bold;
                                  "
                                >
                                  {{ item.promoCode }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-card>
                          </router-link>
                        </v-flex>
                        <v-flex
                          xs6
                          text-left
                          pt-3
                          style="
                            font-size: 12px;
                            color: #000000;
                            font-weight: bold;
                          "
                        >
                          Change Promo Code Status
                        </v-flex>
                        <v-flex text-right xs6 pt-3>
                          <!-- <v-switch v-model="item.status"  x-small class="mx-auto" label="Enable/Disable Promo code" @click="ChangePromocodeStatus(item._id)">
                         </v-switch> -->

                          <v-btn
                            v-if="item.status == 'active'"
                            x-small
                            dark
                            @click="ChangePromocodeStatus(item._id)"
                            color="green"
                          >
                            Active</v-btn
                          >

                          <v-btn
                            v-if="item.status == 'inactive'"
                            x-small
                            dark
                            @click="ChangePromocodeStatus(item._id)"
                            color="error"
                          >
                            Inactive</v-btn
                          >
                        </v-flex>
                        <v-flex text-center xs12 pt-3 pb-3>
                          <span style="font-size: 12px; color: #000000"
                            >Offer validity:</span
                          >
                          <br />
                          <span
                            class="showLine"
                            style="font-size: 13px; color: #000000"
                          >
                            <span
                              style="font-weight: bold"
                              v-if="item.vaidFromDate && item.validToDate"
                            >
                              {{ formatDate(item.vaidFromDate) }}
                              <!-- {{ formatTime(item.startingTime) }} -->
                              to
                              {{ formatDate(item.validToDate) }}
                              <!-- {{ formatTime(item.endingTime) }} -->
                            </span>
                          </span>
                        </v-flex>
                        <template v-if="item.description">
                          <v-flex xs12 text-left px-2>
                            <span
                              style="
                                font-size: 13px;
                                color: #000000;
                                border-bottom: 2px soild black;
                              "
                            >
                              <b>Description</b>
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left px-2>
                            <span style="font-size: 13px; color: #000000">
                              {{ item.description }}
                            </span>
                          </v-flex>
                          <v-flex xs12 text-left px-2 py-2>
                            <v-divider></v-divider>
                          </v-flex>
                        </template>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Discount</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <span style="font-size: 13px; color: #000000">
                            <b> {{ item.discount }} % </b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>is FirstOrder</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <!-- <span style="font-size: 13px; color: #000000">
                            {{ item.isForFirstOrder }}
                          </span> -->
                          <v-icon
                            x-small
                            color="green"
                            v-if="item.isForFirstOrder == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Free Delivery</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <!-- <span style="font-size: 13px; color: #000000">
                            {{ item.isFreeDelivery }}
                          </span> -->

                          <v-icon
                            x-small
                            color="green"
                            v-if="item.isFreeDelivery == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Free Packing Charge</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <!-- <span style="font-size: 13px; color: #000000">
                            {{ item.isFreePackingCharge }}
                          </span> -->
                          <v-icon
                            x-small
                            color="green"
                            v-if="item.isFreePackingCharge == true"
                            >mdi-check-circle</v-icon
                          >
                          <v-icon x-small color="red" v-else
                            >mdi-close-circle</v-icon
                          >
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Maximum KM</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <span style="font-size: 13px; color: #000000">
                            {{ item.maxKm }}
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2 pt-1>
                          <span
                            style="
                              font-size: 13px;
                              color: #000000;
                              border-bottom: 2px soild black;
                            "
                          >
                            <b>Maximum Amount (Rs)</b>
                          </span>
                        </v-flex>
                        <v-flex xs6 text-left px-2>
                          <span style="font-size: 13px; color: #000000">
                           <b> {{ item.maxAmount }} </b>
                          </span>
                        </v-flex>

                        <!-- <v-flex text-center xs12 pt-3>
                          <span
                            class="showLine"
                            style="font-size: 13px; color: #000000"
                            v-html="item.description"
                          >
                          </span>
                        </v-flex> -->
                        <!-- <v-btn style="rot" @click="rot = rot + 90">
                          Rotate 90 </v-btn
                        > -->

                        <!-- <img
                          :style="{ transform: 'rotate(' + rot + 'deg' + ')' }"
                        v-if="item.photo"
                        v-viewer
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        :src="baseURL + '/file/get/' + item.photo"
                        height="180px"
                      /> -->
                        <v-flex py-5 xl6 lg6 md6 sm6 xs6 px-5 justify-center>
                          <v-dialog v-model="item.delete" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                class="mr-2"
                                outlined
                                block
                                v-on="on"
                                v-bind="attrs"
                                color="red"
                              >
                                Delete
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title
                                >Are you sure you want to delete this
                                Offer?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="item.delete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="deleteItem(item)"
                                  >OK</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                        <v-flex py-5 xl6 lg6 md6 sm6 xs6 px-5 justify-center>
                          <v-btn
                            small
                            class="mr-2"
                            outlined
                            block
                            color="green"
                            @click="editSlider(item)"
                          >
                            Edit
                          </v-btn>
                        </v-flex>
                        <br />
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout pt-15 justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span style="font-size: 22px; letter-spacing: 1px">
                  No Data Found...
                </span>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="editdialog" max-width="800px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Promo Code</span>
              </v-card-title>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    
                    <v-text-field
                      label="Promo Code"
                      v-model="editingitem.promoCode"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 pl-0 pl-sm-4>
                  
                    <v-text-field
                    
                      label="Discount (Percentage)"
                      v-model="editingitem.discount"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-text-field
                      label="Description"
                      v-model="editingitem.description"
                    >
                    </v-text-field>
                  </v-flex>
                  
                   <v-flex xs12 text-left>
                    <v-text-field
                      label="Maximum Amount"
                      v-model="editingitem.maxAmount"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-switch
                      label="Is free Delivery"
                      v-model="editingitem.isFreeDelivery"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-text-field
                      label="max KM "
                      :disabled="
                        editingitem.freeDelivery == false ? true : false
                      "
                      v-model="editingitem.maxKm"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 text-left>
                    <v-switch
                      label="Is free Packing Charge"
                      v-model="editingitem.isFreePackingCharge"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 text-left>
                    <v-switch
                      label="Is for 1st Order"
                      v-model="editingitem.isForFirstOrder"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout wrap pt-3>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu5"
                      v-model="menu5"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.vaidFromDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.vaidFromDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.vaidFromDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu5 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu5.save(editingitem.vaidFromDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu6"
                      v-model="menu6"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.validToDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.validToDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.validToDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu6 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu6.save(editingitem.validToDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <!-- <v-layout wrap pt-3>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu8"
                      v-model="menu8"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editingitem.startingTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.startingTime"
                          :rules="[rules.required]"
                          label="Starting Time"
                          prepend-icon="mdi-clock"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="menu8"
                        v-model="editingitem.startingTime"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu8 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu8.save(editingitem.startingTime)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu7"
                      v-model="menu7"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editingitem.endingTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.endingTime"
                          :rules="[rules.required]"
                          prepend-icon="mdi-clock"
                          label="Ending Time"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="menu7"
                        v-model="editingitem.endingTime"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu7 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu7.save(editingitem.endingTime)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout> -->
                <!-- <v-layout wrap>
                  <v-flex xs12 md12 lg12>
                    <ImageComp
                      :singleImage="editingitem.photo"
                      :pageId="editingitem._id"
                      @stepper="winStepper"
                      :height="9"
                      :width="16"
                      :heading="'Upload offer Image (Aspect Ratio: 16/9)'"
                      :componentType="'offerImage'"
                    />
                  </v-flex>
                </v-layout> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editdialog = false">
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="edit(editingitem._id)"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
        <div class="text-center pb-5">
          <v-pagination
            :length="pages"
            :total-visible="8"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import ImageComp from "@/components/Common/singleImage";
// import { VueEditor } from "vue2-editor";
export default {
  components: {
    // VueEditor,
    // ImageComp,
  },
  data() {
    return {
      promoCode: {
        max:null,
        code: null,
        description: null,
        discount: null,
        maxKM: null,
        freeDelivery: false,
        packingCharge: false,
        firstOrder: false,
        startDate: null,
        endDate: null,
        maxAmount:null,
      },

      ServerError: false,
      widthOfCard: "250px",
      rot: 0,
      menu: false,
      menu1: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      products: [],
      offerData: {
        userid: null,
        startingDate: new Date().toISOString().substr(0, 10),
        endingDate: new Date().toISOString().substr(0, 10),
        startingTime: null,
        endingTime: null,
        offerType: "product",
        productId: null,
      },
      formDataCover: new FormData(),
      offerImage: null,
      showSnackbar: false,
      msg: null,
      pages: 1,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      delete: false,
      dialogDelete: false,
      dialog: false,
      dialog1: false,
      editdialog: false,
      editingitem: [],
      offerList: [],
      data: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
      Rules: [(value) => !!value || "Required."],
      titleRule: [(v) => v.length < 50 || "Min 50 characters"],
      sellers: [],
    };
  },

  mounted() {
    this.getData();
    // this.getSellers();
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    ChangePromocodeStatus(value) {
      this.appLoading = true;
      axios({
        url: "/promocode/change/status",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: value,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.getData();
          } else {
            this.showSnackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getProduct(sellerId) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: sellerId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      if (window_data.type == "offerImage") {
        this.offerImage = window_data.selectedFiles;
      }
      if (window_data.type == "offerCoverImage") {
        this.offerCoverImage = window_data.selectedFiles;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/promocode/getlist/admin",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },

        params: {
          page: this.currentPage,
          limit: 50,
        },
      })
        .then((response) => {
          this.offerList = response.data.data;

          this.pages = Math.ceil(response.data.totalLength / 50);
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSellers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.sellers = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    add() {
      this.appLoading = true;

      axios({
        url: "/admin/add/promocode",
        method: "POST",
        data: {
          promoCode: this.promoCode.code,
          description: this.promoCode.description,
          discount: this.promoCode.discount,
          maxKm: this.promoCode.maxKM,
          isFreeDelivery: this.promoCode.freeDelivery,
          isFreePackingCharge: this.promoCode.packingCharge,
          isForFirstOrder: this.promoCode.firstOrder,
          vaidFromDate: this.promoCode.startDate,
          validToDate: this.promoCode.endDate,
          maxAmount: this.promoCode.maxAmount,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.imgId = response.data.id;
            if (this.offerImage) this.uploadImage(response.data.id);
            this.getData();
            this.msg = "Added Sucessfully";
            this.showSnackbar = true;
            Object.keys(this.offerData).forEach(
              (key) => (this.offerData[key] = null)
            );
            this.link = null;
            this.title = null;
            this.caption = null;
            this.date = null;
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      //   this.formDataCover.append("userid", this.editingitem.seller);
      //   this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("descriptionn", this.editingitem.description);
      this.formDataCover.append("promoCode", this.editingitem.promoCode);
      this.formDataCover.append("discount", this.editingitem.discount);
      this.formDataCover.append("maxKm", this.editingitem.maxKm);
      this.formDataCover.append("maxAmount", this.editingitem.maxAmount);
      this.formDataCover.append("isFreeDelivery", this.editingitem.isFreeDelivery);


      this.formDataCover.append(
        "isFreeDelivery",
        this.editingitem.freeDelivery
      );
      this.formDataCover.append(
        "isFreePackingCharge ",
        this.editingitem.isFreePackingCharge
      );
      this.formDataCover.append(
        "isForFirstOrder",
        this.editingitem.isForFirstOrder
      );
      this.formDataCover.append("vaidFromDate ", this.editingitem.vaidFromDate);
      this.formDataCover.append("validToDate", this.editingitem.validToDate);

      //   this.formDataCover.append("startingDate", this.editingitem.startingDate);
      //   this.formDataCover.append("startingTime", this.editingitem.startingTime);
      //   this.formDataCover.append("endingDate", this.editingitem.endingDate);
      //   this.formDataCover.append("endingTime", this.editingitem.endingTime);
      //   this.formDataCover.append("photo", this.offerImage);
      this.formDataCover.append("id", this.editingitem._id);
      var Mydata = {};
      Mydata.description = this.editingitem.description;
      Mydata.promoCode = this.editingitem.promoCode;
      Mydata.discount = this.editingitem.discount;
      Mydata.maxKm = this.editingitem.maxKm;
      Mydata.maxAmount = this.editingitem.maxAmount;
      Mydata.isFreeDelivery = this.editingitem.isFreeDelivery;
      Mydata.isFreePackingCharge = this.editingitem.isFreePackingCharge;
      Mydata.isForFirstOrder = this.editingitem.isForFirstOrder;
      Mydata.id = this.editingitem._id;
      Mydata.vaidFromDate = this.editingitem.vaidFromDate;
      Mydata.validToDate = this.editingitem.validToDate;
      axios({
        method: "POST",
        url: "/admin/edit/promocode",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: Mydata,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.formDataCover = new FormData();
            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;

      //   if (this.editingitem.sellerId) {
      //     this.editingitem.seller = item.sellerId.uid;
      //     this.getProduct(item.sellerId.uid);
      //   }
      //   if (this.editingitem.productId)
      //     this.editingitem.product = item.productId._id;
      // this.editingitem.startingDate = this.editingitem.starting.slice(0, 10);
      // this.editingitem.endingDate = this.editingitem.ending.slice(0, 10);
      // this.editingitem.startingTime = this.editingitem.starting.slice(11, 16);
      // this.editingitem.endingTime = this.editingitem.ending.slice(11, 16);
      this.editdialog = true;
      //    this.editingitem.vaidFromDate =  item.vaidFromDate.splice(0,10);
      //   this.editingitem.validToDate =  item.validToDate.splice(0,10)
    },
    deleteItem(r) {
      this.appLoading = true;
      axios({
        url: "/promocode/delete",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: r._id,
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },

    uploadImage(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("photo", this.offerImage);

      axios({
        method: "POST",
        url: "/admin/seller/offer/edit",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.offerImage = null;

            this.showSnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>